import useIsomorphicLayoutEffect from '@react/shared/helpers/useIsomorphicLayoutEffect';
import { getDimensionObject } from '@react/shared/hooks/useDimensions';
import { useCallback, useState } from 'react';

export function useLiveDimensions({ liveMeasure = true }) {
  const [dimensions, setDimensions] = useState({});
  const [node, setNode] = useState(null);

  const ref = useCallback((node) => {
    setNode(node);
  }, []);

  useIsomorphicLayoutEffect(() => {
    if (node) {
      const measure = () =>
        window.requestAnimationFrame(() =>
          setDimensions(getDimensionObject({ el: node }))
        );
      measure();

      if (liveMeasure) {
        window.addEventListener('resize', measure);
        window.addEventListener('scroll', measure);

        return () => {
          window.removeEventListener('resize', measure);
          window.removeEventListener('scroll', measure);
        };
      }
    }
    return () => {};
  }, [node]);

  return [ref, dimensions, node];
}
